import { PropsWithChildren, useEffect } from 'react';

import { useAppDispatch } from '@/store/hooks';
import { clearAllProjectStats, clearAllSessionStats } from '@/store/slices/stats';

const StatsCleanupWrapper = ({ children }: PropsWithChildren<unknown>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(clearAllProjectStats());
      dispatch(clearAllSessionStats());
    };
  }, [dispatch]);

  return <>{children}</>;
};

export default StatsCleanupWrapper;
